<template>
  <div class="">
    <nav class="navbar navbar-light bg-light-translucent justify-content-between">
      <template v-if="path == '/'">
        <a class="navbar-brand" href="#">
          <img src="assets/TfNSW Logo.png" height="50" >
        </a>
      </template>
      <template v-else>
        <a class="navbar-brand" href="#"></a>
      </template>
      <form class="form-inline my-2 my-lg-0">
        <div class="container">
          <img src="assets/hamburgerwhite.png" class="d-inline-block align-top" height="40">
        </div>
      </form>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    path: String
  },
  mounted() {
    console.log(this.path);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #header {
    border-style: none none solid none;
    border-width: thin;
    border-color: lightgray;
  }
</style>
